function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from "react";
import { PageBaseComponent } from "../../library/cms/page-components";
import EditIcon from "../../library/cms/edit-icon";
import { MediaManagerController } from "../../library/cms/media-manager";

class GalleryItem extends React.Component {
  render() {
    var item = this.props.item;
    var src = item.url;
    var title = item.title;
    var meta = item.meta;
    return /*#__PURE__*/React.createElement("div", {
      className: "content-gallery-item"
    }, /*#__PURE__*/React.createElement("div", {
      className: "img-container"
    }, /*#__PURE__*/React.createElement("img", {
      src: src
    }), /*#__PURE__*/React.createElement("h3", null, meta), /*#__PURE__*/React.createElement("div", null, title)), /*#__PURE__*/React.createElement("div", {
      className: "bottom-border"
    }), /*#__PURE__*/React.createElement("div", {
      className: "right-border"
    }));
  }

}

export default class AboutGallery extends PageBaseComponent {
  constructor(props) {
    super(props);

    _defineProperty(this, "onFilesSelected", files => {
      this.state.component.content.media = files;
      this.setState(this.state.component);
    });

    _defineProperty(this, "onFilesCancel", () => {});

    _defineProperty(this, "onEditClick", event => {
      this.mediaController.mode = 'multi-select';
      this.mediaController.show(this.state.component.content.media);
    });
  }

  componentDidMount() {
    super.componentDidMount();
  }

  get nodes() {
    return this.state.component.content.media.map(file => {
      return /*#__PURE__*/React.createElement(GalleryItem, {
        item: file,
        key: file.id
      });
    });
  }

  render() {
    var nodes = this.nodes;
    var cls = 'content-gallery about top-margin';
    var postUrl = '/api/MediaFile';
    if (this.props.postUrl) postUrl = this.props.postUrl;
    return /*#__PURE__*/React.createElement("div", {
      className: cls
    }, nodes, /*#__PURE__*/React.createElement(EditIcon, {
      onClick: this.onEditClick,
      active: this.state.component.active,
      cls: this.props.iconCss
    }, /*#__PURE__*/React.createElement(MediaManagerController, {
      postUrl: postUrl,
      data: this.props.mediaManagerData,
      ref: ref => this.mediaController = ref,
      onFilesSelected: this.onFilesSelected,
      onCancel: this.onFilesCancel
    })));
  }

}